import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthOrg } from "../context/AuthOrgContext";
import Loader from "../components/Loader";
import { useLocation } from "react-router-dom";
import { CT_API_ENDPOINT } from "../utils";
import { toast } from "../common/Popover";
import Block from '../components/block';
import { Meta } from "../interfaces/apiMeta";
import axios from "../apiServices/monitoredAxios";
import applyCaseMiddleware from 'axios-case-converter';
import { handleApiError } from "../utils/errorHandler";
import authService from "../apiServices/authService";
// import { instrumentAxiosInstance } from "../monitoring";


interface ApiResponse {
    meta: Meta;
    data: {
        token: string;
        userDetails: any;
        wabaDetails: any;
        orgDetails: any;
    };
}

// Create axios instance with case middleware
const caseAdaptedAxios = applyCaseMiddleware(axios.create());
// instrumentAxiosInstance(caseAdaptedAxios);

const SignedLogin: React.FC = () => {
    const navigate = useNavigate();
    const { login: orgLogin } = useAuthOrg();
    const location = useLocation();

    const [exit, setExit] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('sessionToken');

        const verifyAndNavigate = async () => {
            if (token) {
                setIsVerifying(true);
                try {
                    await verifyToken(token);
                } finally {
                    if (isMounted) setIsVerifying(false);
                }
            }
        };

        verifyAndNavigate();

        return () => {
            isMounted = false;
        };
    }, [location.search]);

    const verifyToken = async (token: string) => {
        try {
            const response = await caseAdaptedAxios.post<ApiResponse>(
                `${CT_API_ENDPOINT}/auth/v2/verify-ctwa-token`,
                {},
                {
                    headers: {
                        Authorization: token
                    }
                }
            );

            if (response.data?.meta?.code === 200) {
                const ctToken = "crimson_" + response.data.data.token;

                // Call ct-login with the token
                const ctLoginResponse = await authService.ctLogin(ctToken);

                if (ctLoginResponse.meta.code === 200) {
                    const { userDetails, organizationDetails } = ctLoginResponse.data;

                    orgLogin({
                        token: ctToken, // Keep the token for session
                        userDetails: userDetails,
                        organizationDetails: organizationDetails
                    });

                    navigate('/home', { replace: true });
                } else {
                    throw new Error(ctLoginResponse.meta.message || 'CT Login failed');
                }
            }
        } catch (error) {
            setExit(true);
            toast('error', 'Invalid or expired session token', 2);
            handleApiError(error, 'token-verification', 'Token verification failed');
            navigate('/logout')
        }
    }

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                background: "#f0f2f5",
            }}
        >
            {exit ? (
                <Block>
                    <h1 className="text-green-600 text-2xl text-center mb-4">
                        Thank you
                    </h1>
                    <p className="text-gray-600 text-base text-center">
                        Successfully logged out.
                    </p>
                </Block>
            ) : isVerifying ? (
                <Loader closable={false} />
            ) : null}
        </div>
    );
};

export default SignedLogin;
